import React from 'react';
import type { IconProps } from './IconPlus';

export const IconSearch: React.FC<IconProps> = ({ size = 20, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <circle cx="9" cy="9" r="6" stroke={color} strokeWidth="2"/>
    <path d="M14 14L18 18" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
